import sliceCreator from '../../index.jsx';
import {CREATE_SALES_TARGET} from '../../../constants/index.jsx';
const _createSalesTargetAction = sliceCreator('CREATE_SALES_TARGET', CREATE_SALES_TARGET, 'post');

const { asyncAction: createSalesTargetAction, reducer, clearData: clearCreateSalesTargetAction } = _createSalesTargetAction;

export default reducer;

export {
    createSalesTargetAction,
    clearCreateSalesTargetAction
}